import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15e55cba&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e55cba')) {
      api.createRecord('15e55cba', component.options)
    } else {
      api.reload('15e55cba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15e55cba&", function () {
      api.rerender('15e55cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/returnVisitQuery/index.vue"
export default component.exports